import React from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./ReUploadArchive.scss";

const ReUploadArchive = ({ title, content, image }) => {
  const navigate = useNavigate();

  const handlereproductionVisit = () => {
    navigate("/reproduction");
  };

  const handleArchiveVisit = () => {
    navigate("/archive");
  };

  return (
    <>
      <section className="rearchive-block">
        <div className="retopImage">
          <div className="rediv-archive-image">
            <div
              className="rearchive-image"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </div>
          <div className="rearchive-content">
            <div className="rearchive-header">
              <h2>{title}</h2>
            </div>
            <p className="retext-content">{content}</p>
            <div className="rebottom-section2">
              <div className="rebottom-controls">
                <div className="rebuttons-group">
                  <button
                    className="rebuttons3-button1"
                    onClick={handlereproductionVisit}
                  >
                    Restored Collection
                  </button>
                  <button onClick={handleArchiveVisit}>
                    Access the Archive
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rebottom-section2"></div>
      </section>
    </>
  );
};

export default ReUploadArchive;
